import { createContext, useContext, useState, useCallback } from 'react';
import BookingModal from '../components/BookingModal';

const BookingContext = createContext(null);

export function BookingProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openModal = useCallback(() => setOpen(true), []);
  const closeModal = useCallback(() => setOpen(false), []);

  return (
    <BookingContext.Provider value={{ openModal }}>
      {children}
      <BookingModal isOpen={open} onClose={closeModal} />
    </BookingContext.Provider>
  );
}

export function useBooking() {
  const ctx = useContext(BookingContext);
  if (!ctx) throw new Error('useBooking must be used within BookingProvider');
  return ctx;
}
